import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/install.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install [<package-spec> ...]

aliases: add, i, in, ins, inst, insta, instal, isnt, isnta, isntal, isntall
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/install.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This command installs a package and any packages that it depends on. If the
package has a package-lock, or an npm shrinkwrap file, or a yarn lock file,
the installation of dependencies will be driven by that, respecting the
following order of precedence:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`npm-shrinkwrap.json`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`package-lock.json`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`yarn.lock`}</inlineCode></li>
    </ul>
    <p>{`See `}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/package-lock-json"
      }}>{`package-lock.json`}</a>{` and
`}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-shrinkwrap"
      }}><inlineCode parentName="a">{`npm shrinkwrap`}</inlineCode></a>{`.`}</p>
    <p>{`A `}<inlineCode parentName="p">{`package`}</inlineCode>{` is:`}</p>
    <ul>
      <li parentName="ul">{`a) a folder containing a program described by a
`}<a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-json"
        }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{` file`}</li>
      <li parentName="ul">{`b) a gzipped tarball containing (a)`}</li>
      <li parentName="ul">{`c) a url that resolves to (b)`}</li>
      <li parentName="ul">{`d) a `}<inlineCode parentName="li">{`<name>@<version>`}</inlineCode>{` that is published on the registry (see
`}<a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}><inlineCode parentName="a">{`registry`}</inlineCode></a>{`) with (c)`}</li>
      <li parentName="ul">{`e) a `}<inlineCode parentName="li">{`<name>@<tag>`}</inlineCode>{` (see `}<a parentName="li" {...{
          "href": "/cli/v8/commands/npm-dist-tag"
        }}><inlineCode parentName="a">{`npm dist-tag`}</inlineCode></a>{`) that
points to (d)`}</li>
      <li parentName="ul">{`f) a `}<inlineCode parentName="li">{`<name>`}</inlineCode>{` that has a "latest" tag satisfying (e)`}</li>
      <li parentName="ul">{`g) a `}<inlineCode parentName="li">{`<git remote url>`}</inlineCode>{` that resolves to (a)`}</li>
    </ul>
    <p>{`Even if you never publish your package, you can still get a lot of benefits
of using npm if you just want to write a node program (a), and perhaps if
you also want to be able to easily install it elsewhere after packing it up
into a tarball (b).`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install`}</inlineCode>{` (in a package directory, no arguments):`}</p>
        <p parentName="li">{`  Install the dependencies to the local `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folder.`}</p>
        <p parentName="li">{`  In global mode (ie, with `}<inlineCode parentName="p">{`-g`}</inlineCode>{` or `}<inlineCode parentName="p">{`--global`}</inlineCode>{` appended to the command),
it installs the current package context (ie, the current working
directory) as a global package.`}</p>
        <p parentName="li">{`  By default, `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` will install all modules listed as
dependencies in `}<a parentName="p" {...{
            "href": "/cli/v8/configuring-npm/package-json"
          }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{`.`}</p>
        <p parentName="li">{`  With the `}<inlineCode parentName="p">{`--production`}</inlineCode>{` flag (or when the `}<inlineCode parentName="p">{`NODE_ENV`}</inlineCode>{` environment
variable is set to `}<inlineCode parentName="p">{`production`}</inlineCode>{`), npm will not install modules listed
in `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{`. To install all modules listed in both
`}<inlineCode parentName="p">{`dependencies`}</inlineCode>{` and `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{` when `}<inlineCode parentName="p">{`NODE_ENV`}</inlineCode>{` environment
variable is set to `}<inlineCode parentName="p">{`production`}</inlineCode>{`, you can use `}<inlineCode parentName="p">{`--production=false`}</inlineCode>{`.`}</p>
        <blockquote parentName="li">
          <p parentName="blockquote">{`NOTE: The `}<inlineCode parentName="p">{`--production`}</inlineCode>{` flag has no particular meaning when adding a
dependency to a project.`}</p>
        </blockquote>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install <folder>`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  If `}<inlineCode parentName="p">{`<folder>`}</inlineCode>{` sits inside the root of your project, its dependencies will be installed and may
be hoisted to the top-level `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` as they would for other
types of dependencies. If `}<inlineCode parentName="p">{`<folder>`}</inlineCode>{` sits outside the root of your project,
`}<em parentName="p">{`npm will not install the package dependencies`}</em>{` in the directory `}<inlineCode parentName="p">{`<folder>`}</inlineCode>{`,
but it will create a symlink to `}<inlineCode parentName="p">{`<folder>`}</inlineCode>{`.`}</p>
        <blockquote parentName="li">
          <p parentName="blockquote">{`NOTE: If you want to install the content of a directory like a package from the registry instead of creating a link, you would need to use the `}<inlineCode parentName="p">{`--install-links`}</inlineCode>{` option.`}</p>
        </blockquote>
        <p parentName="li">{`  Example:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install ../../other-package --install-links
npm install ./sub-package
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install <tarball file>`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Install a package that is sitting on the filesystem.  Note: if you just
want to link a dev directory into your npm root, you can do this more
easily by using `}<a parentName="p" {...{
            "href": "/cli/v8/commands/npm-link"
          }}><inlineCode parentName="a">{`npm link`}</inlineCode></a>{`.`}</p>
        <p parentName="li">{`  Tarball requirements:`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li">{`The filename `}<em parentName="p">{`must`}</em>{` use `}<inlineCode parentName="p">{`.tar`}</inlineCode>{`, `}<inlineCode parentName="p">{`.tar.gz`}</inlineCode>{`, or `}<inlineCode parentName="p">{`.tgz`}</inlineCode>{` as the
extension.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`The package contents should reside in a subfolder inside the tarball
(usually it is called `}<inlineCode parentName="p">{`package/`}</inlineCode>{`). npm strips one directory layer
when installing the package (an equivalent of `}<inlineCode parentName="p">{`tar x
--strip-components=1`}</inlineCode>{` is run).`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`The package must contain a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file with `}<inlineCode parentName="p">{`name`}</inlineCode>{` and
`}<inlineCode parentName="p">{`version`}</inlineCode>{` properties.`}</p>
            <p parentName="li">{`Example:`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`npm install ./package.tgz
`}</code></pre>
          </li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install <tarball url>`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Fetch the tarball url, and then install it.  In order to distinguish between
this and other options, the argument must start with "http://" or "https://"`}</p>
        <p parentName="li">{`  Example:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install https://github.com/indexzero/forever/tarball/v0.5.6
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install [<@scope>/]<name>`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Do a `}<inlineCode parentName="p">{`<name>@<tag>`}</inlineCode>{` install, where `}<inlineCode parentName="p">{`<tag>`}</inlineCode>{` is the "tag" config. (See
`}<a parentName="p" {...{
            "href": "/cli/v8/using-npm/config"
          }}><inlineCode parentName="a">{`config`}</inlineCode></a>{`. The config's default value is `}<inlineCode parentName="p">{`latest`}</inlineCode>{`.)`}</p>
        <p parentName="li">{`  In most cases, this will install the version of the modules tagged as
`}<inlineCode parentName="p">{`latest`}</inlineCode>{` on the npm registry.`}</p>
        <p parentName="li">{`  Example:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install sax
`}</code></pre>
        <p parentName="li">{`  `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` saves any specified packages into `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{` by default.
Additionally, you can control where and how they get saved with some
additional flags:`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`-P, --save-prod`}</inlineCode>{`: Package will appear in your `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{`. This
is the default unless `}<inlineCode parentName="p">{`-D`}</inlineCode>{` or `}<inlineCode parentName="p">{`-O`}</inlineCode>{` are present.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`-D, --save-dev`}</inlineCode>{`: Package will appear in your `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{`.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`-O, --save-optional`}</inlineCode>{`: Package will appear in your
`}<inlineCode parentName="p">{`optionalDependencies`}</inlineCode>{`.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`--no-save`}</inlineCode>{`: Prevents saving to `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{`.`}</p>
            <p parentName="li">{`When using any of the above options to save dependencies to your
package.json, there are two additional, optional flags:`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`-E, --save-exact`}</inlineCode>{`: Saved dependencies will be configured with an
exact version rather than using npm's default semver range operator.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`-B, --save-bundle`}</inlineCode>{`: Saved dependencies will also be added to your
`}<inlineCode parentName="p">{`bundleDependencies`}</inlineCode>{` list.`}</p>
            <p parentName="li">{`Further, if you have an `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` or `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{`
then it will be updated as well.`}</p>
            <p parentName="li"><inlineCode parentName="p">{`<scope>`}</inlineCode>{` is optional. The package will be downloaded from the registry
associated with the specified scope. If no registry is associated with
the given scope the default registry is assumed. See
`}<a parentName="p" {...{
                "href": "/cli/v8/using-npm/scope"
              }}><inlineCode parentName="a">{`scope`}</inlineCode></a>{`.`}</p>
            <p parentName="li">{`Note: if you do not include the @-symbol on your scope name, npm will
interpret this as a GitHub repository instead, see below. Scopes names
must also be followed by a slash.`}</p>
            <p parentName="li">{`Examples:`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`npm install sax
npm install githubname/reponame
npm install @myorg/privatepackage
npm install node-tap --save-dev
npm install dtrace-provider --save-optional
npm install readable-stream --save-exact
npm install ansi-regex --save-bundle
`}</code></pre>
            <p parentName="li"><strong parentName="p">{`Note`}</strong>{`: If there is a file or folder named `}<inlineCode parentName="p">{`<name>`}</inlineCode>{` in the current
working directory, then it will try to install that, and only try to
fetch the package by name if it is not valid.`}</p>
          </li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install <alias>@npm:<name>`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Install a package under a custom alias. Allows multiple versions of
a same-name package side-by-side, more convenient import names for
packages with otherwise long ones, and using git forks replacements
or forked npm packages as replacements. Aliasing works only on your
project and does not rename packages in transitive dependencies.
Aliases should follow the naming conventions stated in
`}<a parentName="p" {...{
            "href": "https://www.npmjs.com/package/validate-npm-package-name#naming-rules"
          }}><inlineCode parentName="a">{`validate-npm-package-name`}</inlineCode></a>{`.`}</p>
        <p parentName="li">{`  Examples:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install my-react@npm:react
npm install jquery2@npm:jquery@2
npm install jquery3@npm:jquery@3
npm install npa@npm:npm-package-arg
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install [<@scope>/]<name>@<tag>`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Install the version of the package that is referenced by the specified tag.
If the tag does not exist in the registry data for that package, then this
will fail.`}</p>
        <p parentName="li">{`  Example:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install sax@latest
npm install @myorg/mypackage@latest
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install [<@scope>/]<name>@<version>`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Install the specified version of the package.  This will fail if the
version has not been published to the registry.`}</p>
        <p parentName="li">{`  Example:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install sax@0.1.1
npm install @myorg/privatepackage@1.5.0
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install [<@scope>/]<name>@<version range>`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Install a version of the package matching the specified version range.
This will follow the same rules for resolving dependencies described in
`}<a parentName="p" {...{
            "href": "/cli/v8/configuring-npm/package-json"
          }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{`.`}</p>
        <p parentName="li">{`  Note that most version ranges must be put in quotes so that your shell
will treat it as a single argument.`}</p>
        <p parentName="li">{`  Example:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install sax@">=0.1.0 <0.2.0"
npm install @myorg/privatepackage@"16 - 17"
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install <git remote url>`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Installs the package from the hosted git provider, cloning it with
`}<inlineCode parentName="p">{`git`}</inlineCode>{`.  For a full git remote url, only that URL will be attempted.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`<protocol>://[<user>[:<password>]@]<hostname>[:<port>][:][/]<path>[#<commit-ish> | #semver:<semver>]
`}</code></pre>
        <p parentName="li">{`  `}<inlineCode parentName="p">{`<protocol>`}</inlineCode>{` is one of `}<inlineCode parentName="p">{`git`}</inlineCode>{`, `}<inlineCode parentName="p">{`git+ssh`}</inlineCode>{`, `}<inlineCode parentName="p">{`git+http`}</inlineCode>{`, `}<inlineCode parentName="p">{`git+https`}</inlineCode>{`, or
`}<inlineCode parentName="p">{`git+file`}</inlineCode>{`.`}</p>
        <p parentName="li">{`  If `}<inlineCode parentName="p">{`#<commit-ish>`}</inlineCode>{` is provided, it will be used to clone exactly that
commit. If the commit-ish has the format `}<inlineCode parentName="p">{`#semver:<semver>`}</inlineCode>{`, `}<inlineCode parentName="p">{`<semver>`}</inlineCode>{`
can be any valid semver range or exact version, and npm will look for
any tags or refs matching that range in the remote repository, much as
it would for a registry dependency. If neither `}<inlineCode parentName="p">{`#<commit-ish>`}</inlineCode>{` or
`}<inlineCode parentName="p">{`#semver:<semver>`}</inlineCode>{` is specified, then the default branch of the
repository is used.`}</p>
        <p parentName="li">{`  If the repository makes use of submodules, those submodules will be
cloned as well.`}</p>
        <p parentName="li">{`  If the package being installed contains a `}<inlineCode parentName="p">{`prepare`}</inlineCode>{` script, its
`}<inlineCode parentName="p">{`dependencies`}</inlineCode>{` and `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{` will be installed, and the prepare
script will be run, before the package is packaged and installed.`}</p>
        <p parentName="li">{`  The following git environment variables are recognized by npm and will
be added to the environment when running git:`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`GIT_ASKPASS`}</inlineCode></p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`GIT_EXEC_PATH`}</inlineCode></p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`GIT_PROXY_COMMAND`}</inlineCode></p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`GIT_SSH`}</inlineCode></p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`GIT_SSH_COMMAND`}</inlineCode></p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`GIT_SSL_CAINFO`}</inlineCode></p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`GIT_SSL_NO_VERIFY`}</inlineCode></p>
            <p parentName="li">{`See the git man page for details.`}</p>
            <p parentName="li">{`Examples:`}</p>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-bash"
              }}>{`npm install git+ssh://git@github.com:npm/cli.git#v1.0.27
npm install git+ssh://git@github.com:npm/cli#pull/273
npm install git+ssh://git@github.com:npm/cli#semver:^5.0
npm install git+https://isaacs@github.com/npm/cli.git
npm install git://github.com/npm/cli.git#v1.0.27
GIT_SSH_COMMAND='ssh -i ~/.ssh/custom_ident' npm install git+ssh://git@github.com:npm/cli.git
`}</code></pre>
          </li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install <githubname>/<githubrepo>[#<commit-ish>]`}</inlineCode>{`:`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install github:<githubname>/<githubrepo>[#<commit-ish>]`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Install the package at `}<inlineCode parentName="p">{`https://github.com/githubname/githubrepo`}</inlineCode>{` by
attempting to clone it using `}<inlineCode parentName="p">{`git`}</inlineCode>{`.`}</p>
        <p parentName="li">{`  If `}<inlineCode parentName="p">{`#<commit-ish>`}</inlineCode>{` is provided, it will be used to clone exactly that
commit. If the commit-ish has the format `}<inlineCode parentName="p">{`#semver:<semver>`}</inlineCode>{`, `}<inlineCode parentName="p">{`<semver>`}</inlineCode>{`
can be any valid semver range or exact version, and npm will look for
any tags or refs matching that range in the remote repository, much as
it would for a registry dependency. If neither `}<inlineCode parentName="p">{`#<commit-ish>`}</inlineCode>{` or
`}<inlineCode parentName="p">{`#semver:<semver>`}</inlineCode>{` is specified, then the default branch is used.`}</p>
        <p parentName="li">{`  As with regular git dependencies, `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{` and `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{`
will be installed if the package has a `}<inlineCode parentName="p">{`prepare`}</inlineCode>{` script before the
package is done installing.`}</p>
        <p parentName="li">{`  Examples:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install mygithubuser/myproject
npm install github:mygithubuser/myproject
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install gist:[<githubname>/]<gistID>[#<commit-ish>|#semver:<semver>]`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Install the package at `}<inlineCode parentName="p">{`https://gist.github.com/gistID`}</inlineCode>{` by attempting to
clone it using `}<inlineCode parentName="p">{`git`}</inlineCode>{`. The GitHub username associated with the gist is
optional and will not be saved in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>
        <p parentName="li">{`  As with regular git dependencies, `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{` and `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{` will
be installed if the package has a `}<inlineCode parentName="p">{`prepare`}</inlineCode>{` script before the package is
done installing.`}</p>
        <p parentName="li">{`  Example:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install gist:101a11beef
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install bitbucket:<bitbucketname>/<bitbucketrepo>[#<commit-ish>]`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Install the package at `}<inlineCode parentName="p">{`https://bitbucket.org/bitbucketname/bitbucketrepo`}</inlineCode>{`
by attempting to clone it using `}<inlineCode parentName="p">{`git`}</inlineCode>{`.`}</p>
        <p parentName="li">{`  If `}<inlineCode parentName="p">{`#<commit-ish>`}</inlineCode>{` is provided, it will be used to clone exactly that
commit. If the commit-ish has the format `}<inlineCode parentName="p">{`#semver:<semver>`}</inlineCode>{`, `}<inlineCode parentName="p">{`<semver>`}</inlineCode>{` can
be any valid semver range or exact version, and npm will look for any tags
or refs matching that range in the remote repository, much as it would for a
registry dependency. If neither `}<inlineCode parentName="p">{`#<commit-ish>`}</inlineCode>{` or `}<inlineCode parentName="p">{`#semver:<semver>`}</inlineCode>{` is
specified, then `}<inlineCode parentName="p">{`master`}</inlineCode>{` is used.`}</p>
        <p parentName="li">{`  As with regular git dependencies, `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{` and `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{` will
be installed if the package has a `}<inlineCode parentName="p">{`prepare`}</inlineCode>{` script before the package is
done installing.`}</p>
        <p parentName="li">{`  Example:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install bitbucket:mybitbucketuser/myproject
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`npm install gitlab:<gitlabname>/<gitlabrepo>[#<commit-ish>]`}</inlineCode>{`:`}</p>
        <p parentName="li">{`  Install the package at `}<inlineCode parentName="p">{`https://gitlab.com/gitlabname/gitlabrepo`}</inlineCode>{`
by attempting to clone it using `}<inlineCode parentName="p">{`git`}</inlineCode>{`.`}</p>
        <p parentName="li">{`  If `}<inlineCode parentName="p">{`#<commit-ish>`}</inlineCode>{` is provided, it will be used to clone exactly that
commit. If the commit-ish has the format `}<inlineCode parentName="p">{`#semver:<semver>`}</inlineCode>{`, `}<inlineCode parentName="p">{`<semver>`}</inlineCode>{` can
be any valid semver range or exact version, and npm will look for any tags
or refs matching that range in the remote repository, much as it would for a
registry dependency. If neither `}<inlineCode parentName="p">{`#<commit-ish>`}</inlineCode>{` or `}<inlineCode parentName="p">{`#semver:<semver>`}</inlineCode>{` is
specified, then `}<inlineCode parentName="p">{`master`}</inlineCode>{` is used.`}</p>
        <p parentName="li">{`  As with regular git dependencies, `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{` and `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{` will
be installed if the package has a `}<inlineCode parentName="p">{`prepare`}</inlineCode>{` script before the package is
done installing.`}</p>
        <p parentName="li">{`  Example:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install gitlab:mygitlabuser/myproject
npm install gitlab:myusr/myproj#semver:^5.0
`}</code></pre>
      </li>
    </ul>
    <p>{`You may combine multiple arguments and even multiple types of arguments.
For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install sax@">=0.1.0 <0.2.0" bench supervisor
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`--tag`}</inlineCode>{` argument will apply to all of the specified install targets. If
a tag with the given name exists, the tagged version is preferred over
newer versions.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`--dry-run`}</inlineCode>{` argument will report in the usual way what the install
would have done without actually installing anything.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`--package-lock-only`}</inlineCode>{` argument will only update the
`}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{`, instead of checking `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` and downloading
dependencies.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`-f`}</inlineCode>{` or `}<inlineCode parentName="p">{`--force`}</inlineCode>{` argument will force npm to fetch remote resources
even if a local copy exists on disk.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install sax --force
`}</code></pre>
    <h3>{`Configuration`}</h3>
    <p>{`See the `}<a parentName="p" {...{
        "href": "/cli/v8/using-npm/config"
      }}><inlineCode parentName="a">{`config`}</inlineCode></a>{` help doc.  Many of the configuration
params have some effect on installation, since that's most of what npm
does.`}</p>
    <p>{`These are some of the most common options related to installation.`}</p>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`save`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: `}<inlineCode parentName="li">{`true`}</inlineCode>{` unless when using `}<inlineCode parentName="li">{`npm update`}</inlineCode>{` where it defaults to `}<inlineCode parentName="li">{`false`}</inlineCode></li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Save installed packages to a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file as dependencies.`}</p>
    <p>{`When used with the `}<inlineCode parentName="p">{`npm rm`}</inlineCode>{` command, removes the dependency from
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>
    <p>{`Will also prevent writing to `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` if set to `}<inlineCode parentName="p">{`false`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`save-exact`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Dependencies saved to package.json will be configured with an exact version
rather than using npm's default semver range operator.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`global`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Operates in "global" mode, so that packages are installed into the `}<inlineCode parentName="p">{`prefix`}</inlineCode>{`
folder instead of the current working directory. See
`}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/folders"
      }}>{`folders`}</a>{` for more on the differences in behavior.`}</p>
    <ul>
      <li parentName="ul">{`packages are installed into the `}<inlineCode parentName="li">{`{prefix}/lib/node_modules`}</inlineCode>{` folder, instead
of the current working directory.`}</li>
      <li parentName="ul">{`bin files are linked to `}<inlineCode parentName="li">{`{prefix}/bin`}</inlineCode></li>
      <li parentName="ul">{`man pages are linked to `}<inlineCode parentName="li">{`{prefix}/share/man`}</inlineCode></li>
    </ul>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`global-style`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Causes npm to install the package into your local `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folder with
the same layout it uses with the global `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folder. Only your
direct dependencies will show in `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` and everything they depend
on will be flattened in their `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` folders. This obviously will
eliminate some deduping. If used with `}<inlineCode parentName="p">{`legacy-bundling`}</inlineCode>{`, `}<inlineCode parentName="p">{`legacy-bundling`}</inlineCode>{`
will be preferred.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`legacy-bundling`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Causes npm to install the package such that versions of npm prior to 1.4,
such as the one included with node 0.8, can install the package. This
eliminates all automatic deduping. If used with `}<inlineCode parentName="p">{`global-style`}</inlineCode>{` this option
will be preferred.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`omit`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: 'dev' if the `}<inlineCode parentName="li">{`NODE_ENV`}</inlineCode>{` environment variable is set to
'production', otherwise empty.`}</li>
      <li parentName="ul">{`Type: "dev", "optional", or "peer" (can be set multiple times)`}</li>
    </ul>
    <p>{`Dependency types to omit from the installation tree on disk.`}</p>
    <p>{`Note that these dependencies `}<em parentName="p">{`are`}</em>{` still resolved and added to the
`}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` or `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` file. They are just not
physically installed on disk.`}</p>
    <p>{`If a package type appears in both the `}<inlineCode parentName="p">{`--include`}</inlineCode>{` and `}<inlineCode parentName="p">{`--omit`}</inlineCode>{` lists, then
it will be included.`}</p>
    <p>{`If the resulting omit list includes `}<inlineCode parentName="p">{`'dev'`}</inlineCode>{`, then the `}<inlineCode parentName="p">{`NODE_ENV`}</inlineCode>{` environment
variable will be set to `}<inlineCode parentName="p">{`'production'`}</inlineCode>{` for all lifecycle scripts.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`strict-peer-deps`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If set to `}<inlineCode parentName="p">{`true`}</inlineCode>{`, and `}<inlineCode parentName="p">{`--legacy-peer-deps`}</inlineCode>{` is not set, then `}<em parentName="p">{`any`}</em>{`
conflicting `}<inlineCode parentName="p">{`peerDependencies`}</inlineCode>{` will be treated as an install failure, even
if npm could reasonably guess the appropriate resolution based on non-peer
dependency relationships.`}</p>
    <p>{`By default, conflicting `}<inlineCode parentName="p">{`peerDependencies`}</inlineCode>{` deep in the dependency graph will
be resolved using the nearest non-peer dependency specification, even if
doing so will result in some packages receiving a peer dependency outside
the range set in their package's `}<inlineCode parentName="p">{`peerDependencies`}</inlineCode>{` object.`}</p>
    <p>{`When such and override is performed, a warning is printed, explaining the
conflict and the packages involved. If `}<inlineCode parentName="p">{`--strict-peer-deps`}</inlineCode>{` is set, then
this warning is treated as a failure.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`package-lock`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If set to false, then ignore `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` files when installing. This
will also prevent `}<em parentName="p">{`writing`}</em>{` `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` if `}<inlineCode parentName="p">{`save`}</inlineCode>{` is true.`}</p>
    <p>{`This configuration does not affect `}<inlineCode parentName="p">{`npm ci`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`foreground-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Run all build scripts (ie, `}<inlineCode parentName="p">{`preinstall`}</inlineCode>{`, `}<inlineCode parentName="p">{`install`}</inlineCode>{`, and `}<inlineCode parentName="p">{`postinstall`}</inlineCode>{`)
scripts for installed packages in the foreground process, sharing standard
input, output, and error with the main npm process.`}</p>
    <p>{`Note that this will generally make installs run slower, and be much noisier,
but can be useful for debugging.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`ignore-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If true, npm does not run scripts specified in package.json files.`}</p>
    <p>{`Note that commands explicitly intended to run a particular script, such as
`}<inlineCode parentName="p">{`npm start`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm stop`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm restart`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm test`}</inlineCode>{`, and `}<inlineCode parentName="p">{`npm run-script`}</inlineCode>{`
will still run their intended script if `}<inlineCode parentName="p">{`ignore-scripts`}</inlineCode>{` is set, but they
will `}<em parentName="p">{`not`}</em>{` run any pre- or post-scripts.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`audit`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When "true" submit audit reports alongside the current npm command to the
default registry and all registries configured for scopes. See the
documentation for `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-audit"
      }}><inlineCode parentName="a">{`npm audit`}</inlineCode></a>{` for details on what is
submitted.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`bin-links`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Tells npm to create symlinks (or `}<inlineCode parentName="p">{`.cmd`}</inlineCode>{` shims on Windows) for package
executables.`}</p>
    <p>{`Set to false to have it not do this. This can be used to work around the
fact that some file systems don't support symlinks, even on ostensibly Unix
systems.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`fund`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: true`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When "true" displays the message at the end of each `}<inlineCode parentName="p">{`npm install`}</inlineCode>{`
acknowledging the number of dependencies looking for funding. See `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-fund"
      }}><inlineCode parentName="a">{`npm
fund`}</inlineCode></a>{` for details.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`dry-run`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Indicates that you don't want npm to make any changes and that it should
only report what it would have done. This can be passed into any of the
commands that modify your local installation, eg, `}<inlineCode parentName="p">{`install`}</inlineCode>{`, `}<inlineCode parentName="p">{`update`}</inlineCode>{`,
`}<inlineCode parentName="p">{`dedupe`}</inlineCode>{`, `}<inlineCode parentName="p">{`uninstall`}</inlineCode>{`, as well as `}<inlineCode parentName="p">{`pack`}</inlineCode>{` and `}<inlineCode parentName="p">{`publish`}</inlineCode>{`.`}</p>
    <p>{`Note: This is NOT honored by other network related commands, eg `}<inlineCode parentName="p">{`dist-tags`}</inlineCode>{`,
`}<inlineCode parentName="p">{`owner`}</inlineCode>{`, etc.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`install-links`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When set file: protocol dependencies that exist outside of the project root
will be packed and installed as regular dependencies instead of creating a
symlink. This option has no effect on workspaces.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`Algorithm`}</h3>
    <p>{`Given a `}<inlineCode parentName="p">{`package{dep}`}</inlineCode>{` structure: `}<inlineCode parentName="p">{`A{B,C}, B{C}, C{D}`}</inlineCode>{`,
the npm install algorithm produces:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`A
+-- B
+-- C
+-- D
`}</code></pre>
    <p>{`That is, the dependency from B to C is satisfied by the fact that A already
caused C to be installed at a higher level. D is still installed at the top
level because nothing conflicts with it.`}</p>
    <p>{`For `}<inlineCode parentName="p">{`A{B,C}, B{C,D@1}, C{D@2}`}</inlineCode>{`, this algorithm produces:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`A
+-- B
+-- C
   \`-- D@2
+-- D@1
`}</code></pre>
    <p>{`Because B's D@1 will be installed in the top-level, C now has to install
D@2 privately for itself. This algorithm is deterministic, but different
trees may be produced if two dependencies are requested for installation in
a different order.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/folders"
      }}>{`folders`}</a>{` for a more detailed description of
the specific folder structures that npm creates.`}</p>
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/folders"
        }}>{`npm folders`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-update"
        }}>{`npm update`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-audit"
        }}>{`npm audit`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-fund"
        }}>{`npm fund`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-link"
        }}>{`npm link`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-rebuild"
        }}>{`npm rebuild`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/scripts"
        }}>{`npm scripts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-dist-tag"
        }}>{`npm dist-tag`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-uninstall"
        }}>{`npm uninstall`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-shrinkwrap"
        }}>{`npm shrinkwrap`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/package-json"
        }}>{`package.json`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/workspaces"
        }}>{`workspaces`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      